import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useFacturaCompraStore } from '../store/facturaCompraStore';

const estadoColors: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  APR: 'success', PEN: 'warning', ANU: 'error', CER: 'default',
};
const estadoLabels: Record<string, string> = {
  APR: 'Aprobada', PEN: 'Pendiente', ANU: 'Anulada', CER: 'Cerrada',
};

export const FacturasCompraPage: React.FC = () => {
  const navigate = useNavigate();
  const { items, loading, fetchAll } = useFacturaCompraStore();

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const columns: GridColDef[] = [
    { field: 'serie', headerName: 'Serie', width: 80 },
    { field: 'nroDocumento', headerName: 'Nro Doc.', width: 120 },
    {
      field: 'fechaEmision', headerName: 'F. Emision', width: 120,
      valueFormatter: (value: string) => {
        try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; }
      },
    },
    { field: 'proveedor', headerName: 'Proveedor', flex: 1, minWidth: 200, valueGetter: (value: any) => value?.razonSocial || '-' },
    { field: 'nroDocumentoProveedor', headerName: 'Doc. Proveedor', width: 150 },
    { field: 'total', headerName: 'Total', width: 120, type: 'number', valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}` },
    {
      field: 'estado', headerName: 'Estado', width: 120,
      renderCell: (params) => (
        <Chip label={estadoLabels[params.value] || params.value || '-'} color={estadoColors[params.value] || 'default'} size="small" />
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Facturas de Compra</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/compras/factura-compra/nueva')}>Nueva Factura</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid
          rows={items} columns={columns} getRowId={(row) => row.idFacturaCompra}
          loading={loading} pageSizeOptions={[10, 20, 50]}
          initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/compras/factura-compra/${params.row.idFacturaCompra}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick
        />
      </Paper>
    </Box>
  );
};
